import { fieldToTextField } from "formik-mui";
import MaskedInput from "react-text-mask";

import MuiTextField from "@mui/material/TextField";
import { makeStyles } from "@mui/styles";

import Check from "@mui/icons-material/Check";

import { kickBlue } from "~/shared/styles/baseStyles.js";
import { isPharmacyPickupOrderType } from "~/shared/utils/sharedUtils.js";
import { getVisitProduct } from "~/visits/utils/visitCookies.js";
import consultationStyles from "../styles/consultationStyles.js";

export const MAX_WIDTH = 800;

const useConsultStyles = makeStyles(consultationStyles);

export const FormikTextField = (props) => {
  const classes = useConsultStyles();

  return (
    <div className={classes.textField}>
      <label className={classes.label}>{props.labeltext}</label>
      <MuiTextField {...fieldToTextField(props)} id={props.id} />
    </div>
  );
};

export const TextField = (props) => {
  const classes = useConsultStyles();

  return (
    <div className={classes.textField}>
      <label className={classes.label}>{props.labeltext}</label>
      <MuiTextField {...props} id={props.id} />
    </div>
  );
};

export function TextMaskPhone(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      guide={false}
      {...other}
      mask={[
        "(",
        /\d/,
        /\d/,
        /\d/,
        ")",
        " ",
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      placeholder="(123) 456-7890"
      showMask
      type="tel"
    />
  );
}

export const Headline = ({ headline }) => {
  const classes = useConsultStyles();
  return (
    <div
      style={{
        padding: "10px 15px",
        maxWidth: `${MAX_WIDTH + 20}px`,
        alignSelf: "center",
      }}
    >
      <h2 className={classes.cardTitle}>{headline}</h2>
    </div>
  );
};

function getConnectorStyles(step, currentStep) {
  const sharedConnectorStyles = {
    height: "2px",
    width: "100%",
    backgroundColor: "#BABABA",
  };
  const connectorStyles = {
    active: {
      ...sharedConnectorStyles,
      backgroundColor: kickBlue,
    },
  };
  return step < currentStep ? connectorStyles.active : sharedConnectorStyles;
}

function getStepStyles(step, currentStep) {
  const sharedStepCircleStyles = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxSizing: "border-box",
    borderRadius: "100%",
    height: "48px",
    width: "48px",
    fontWeight: "bold",
    fontSize: "20px",
    border: "2px solid #BABABA",
    position: "relative",
  };
  const sharedStepTextStyles = {
    textAlign: "center",
    fontSize: "11px",
    position: "absolute",
    top: "74px",
    fontFamily: "BasisGrotesquePro-Bold",
    whiteSpace: "nowrap",
  };
  const stepStyles = {
    active: {
      circle: {
        ...sharedStepCircleStyles,
        borderColor: kickBlue,
        backgroundColor: kickBlue,
        color: "#fff",
      },
      text: {
        ...sharedStepTextStyles,
        color: kickBlue,
      },
    },
    todo: {
      circle: {
        ...sharedStepCircleStyles,
        borderColor: "#BABABA",
        color: "#BABABA",
      },
      text: {
        ...sharedStepTextStyles,
        color: "#BABABA",
      },
    },
    completed: {
      circle: {
        ...sharedStepCircleStyles,
        borderColor: kickBlue,
        color: kickBlue,
      },
      text: {
        ...sharedStepTextStyles,
        color: kickBlue,
      },
    },
  };

  return step === currentStep
    ? stepStyles.active
    : step < currentStep
      ? stepStyles.completed
      : stepStyles.todo;
}

function Step({ step, currentStep, stepText }) {
  const stepStyles = getStepStyles(step, currentStep);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={stepStyles.circle}>
        {step}
        {currentStep > step && (
          <div
            style={{
              position: "absolute",
              bottom: "30px",
              left: "30px",
              borderRadius: "100%",
              backgroundColor: kickBlue,
              height: "16px",
              width: "16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Check style={{ color: "#fff", fontSize: "13px" }} />
          </div>
        )}
      </div>
      <div style={stepStyles.text}>{stepText}</div>
    </div>
  );
}

export const CheckoutProgress = ({ step, checkoutSessionID }) => {
  const step1Text = isPharmacyPickupOrderType(
    getVisitProduct(checkoutSessionID),
  )
    ? "Order Details"
    : "Shipping Details";
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        maxWidth: "400px",
        width: "100%",
        alignItems: "center",
        padding: "20px 20px 40px",
        position: "relative",
        boxSizing: "border-box",
      }}
    >
      <Step step={1} currentStep={step} stepText={step1Text} />
      <div style={getConnectorStyles(1, step)} />
      <Step step={2} currentStep={step} stepText="Payment Details" />
      <div style={getConnectorStyles(2, step)} />
      <Step step={3} currentStep={step} stepText="Order Complete" />
    </div>
  );
};
